<template>
    <drag-and-drop-wrapper>
        <template v-slot:="{jsPlumbInstance}">
            <div class="track" @click.self="moveToYViaTrack($event.y)">
                <drag-and-drop-draggable
                    :js-plumb-instance="jsPlumbInstance"
                    :containment="true"
                    @drag="draggedToYViaNob($event.pos[1])"
                    @stop="dragStoppedToYViaNob($event.finalPos[1])"
                >
                    <div 
                        class="nob"
                        :class="{ dragging: isDragging }"
                        :style="`top: ${nobTrackPosition}px; height: ${nobHeight}px`"

                        @mousedown="isDragging = true"
                        @mouseup="isDragging = false"
                    />
                </drag-and-drop-draggable>
            </div>
        </template>
    </drag-and-drop-wrapper>
</template>

<script>
import constants from './constants';

import DragAndDropWrapper from "@core/Components/DragAndDrop/DragAndDropWrapper";
import DragAndDropDraggable from "@core/Components/DragAndDrop/DragAndDropDraggable";

export default {
    name: "vertical-scroll",
    components: {
        DragAndDropWrapper,
        DragAndDropDraggable
    },
    mounted() {
        this.updateHeightData();
        
        //ResizeObserver is a fairly new API; wrap it in a conditional for safety
        //Without our observer, the client might experience a small unusable part of the track near the bottom
        //Our element resizes upon loading of our journey builder blocks in the menu area
        if(window.ResizeObserver){
            const observer = new window.ResizeObserver(() => {
                this.updateHeightData();
            });

            observer.observe(this.$el);
            this.resizeObserver = observer;   
        }
    },
    beforeDestroy() {
        if(this.resizeObserver){
            this.resizeObserver.disconnect(); 
        }
    },
    methods: {
        updateHeightData(){
            const { height: trackHeight, y: trackY } = this.$el.getBoundingClientRect();

            //Set trackHeight/trackY only when updated for performance reasons
            //we don't expect resizing to happen often
            this.trackHeight = trackHeight;
            this.trackY = trackY;
        },
        dragStoppedToYViaNob(y){
            //We can't accurately capture mouseout events
            //thus we also need to set our dragging state to false upon drag stop
            this.isDragging = false;

            this.draggedToYViaNob(y);
        },
        draggedToYViaNob(y){
            this.moveNobToY(y);
        },
        moveToYViaTrack(y){
            //y is the position of the track part in the page
            //calculate the actual selected trackY by subtracting the track start y from our given y  
            const trackY = y - this.trackY;
            this.moveNobToY(trackY);
        },
        moveNobToY(y) {
            const newYAreaPercentage = this.toAllowedY(y) / this.trackHeight;
            const newY = this.minTop + (this.coveredArea * newYAreaPercentage);

            this.$emit('update:position', newY);
        },
        toAllowedY(y){
            return Math.max(
                this.minTop,
                Math.min(y, (this.trackHeight - this.nobHeight))
            );
        }
    },
    computed: {
        coveredArea(){
            //max: 1799
            //min: -748
            //area: 2547
            return this.maxTop + -this.minTop;
        },
        nobTrackPosition(){
            //position: 0
            //min: -748
            //max: 1799
            //Difference to min: 748
            //Percentage of area: ~29%
            let positionPercentage = ((this.position - this.minTop) / this.coveredArea);
            positionPercentage = Math.max(0, Math.min(1, positionPercentage));

            //Prevent nob from going out of bounds
            return this.toAllowedY(positionPercentage * this.trackHeight);
        },
        nobHeight(){
            return Math.max(
                this.trackHeight / this.coveredArea * this.trackHeight,
                constants.MINIMUM_NOB_SIZE
            );
        }
    },
    props: {
        minTop: 0,
        maxTop: 0,

        position: 0
    },
    data: () => ({
        resizeObserver: null,
        
        trackHeight: 0,
        trackY: 0,
        isDragging: false
    })
}
</script>

<style scoped lang="scss">
@import "shared";

.track {
    width: $track-width;
    height: $track-size;
}

.nob {
    width: 100%;
}
</style>